
import echarts from './echarts/echarts.vue'
import list from './list/list.vue'
import multiInput from './mult-input/mult-input.vue'
import multiInputShow from './mult-input/mult-input-show.vue'
import multiInputIntro from './mult-input/mult-input-intro.vue'

import scrollTable from './scroll-table/scroll-table.vue'


const vueComponents = {
    "vx-echarts": echarts,
    "vx-list": list,
    "vx-mult-input": multiInput,
    "vx-mult-input-show": multiInputShow,
    "vx-mult-input-intro": multiInputIntro,
    "vx-scroll-table":scrollTable
}


Vue.mixin({
    components: vueComponents,
    // filters: vueFilters
});


// 注册vant的懒加载Lazyload组件
Vue.use(vant.Lazyload);